import { type ReactNode } from 'react'
import { Icon } from '../icons/Icon'
import { Dialog } from '../popups/Dialog'

type LegalModalProps = {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
}

export function LegalModal({ isOpen, onClose, children }: LegalModalProps) {
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const handleBackdropKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose()
    }
  }

  return (
    <Dialog
      className={`!rounded-none !border-0 !border-none`}
      overlayClassName="!rounded-none !border-0 !border-none bg-transparent"
      open={isOpen}
      onClose={onClose}
      hideIcon
      containerClassName="overflow-hidden !border-none"
      variant="fullscreen"
    >
      <div
        className="h-full w-full"
        onClick={handleBackdropClick}
        onKeyDown={handleBackdropKeyDown}
        role="button"
        tabIndex={-1}
        aria-label="Cerrar modal"
      >
        <div
          className={`
            fixed left-1/2 top-1/2 max-h-[90vh] w-[calc(100%-32px)]
            -translate-x-[50%] -translate-y-[50%] overflow-y-auto
            overflow-x-hidden overscroll-contain rounded-base border
            border-neutral-75 bg-white

            md:h-[654px] md:w-[800px]
          `}
          style={{ WebkitOverflowScrolling: 'touch' }}
        >
          <div className="relative">
            <Icon
              name="basic/x"
              size="24px"
              className={`fixed right-4 top-4 cursor-pointer text-neutral-300`}
              onClick={onClose}
            />
            <div
              className={`
                w-full max-w-full cursor-default px-4 pb-14 pt-12

                md:w-[800px] md:max-w-[800px]

                xl:pl-11 xl:pr-[66px]
              `}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}
